import {
  AfterViewInit,
  Component,
  computed,
  OnDestroy,
  OnInit,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { TituloComponent } from '../../../../shared/components/titulo/titulo.component';
import { ButtonPrimaryComponent } from '../../../../shared/components/button-primary/button-primary.component';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe, CommonModule, NgClass } from '@angular/common';
import { ButtonSecondaryComponent } from '../../../../shared/components/button-secondary/button-secondary.component';
import { ErrorMessageComponent } from '../../../../shared/components/error-message/error-message.component';
import { ModalFormService } from 'src/app/shared/components/modal-form/service/modal-form.service';
import { FormCrearAreaComponent } from '../form-crear-area/form-crear-area.component';
import { TeledeteccionArea } from '../../../../model/teledeteccion-area.model';

@Component({
  selector: 'app-modal-teledeteccion',
  imports: [
    TituloComponent,
    ButtonPrimaryComponent,
    MatIconModule,
    ButtonSecondaryComponent,
    ErrorMessageComponent,
    CommonModule,
    FormCrearAreaComponent,
  ],
  templateUrl: './modal-teledeteccion.component.html',
  styleUrl: './modal-teledeteccion.component.scss',
})
export class ModalTeledeteccionComponent implements OnDestroy, OnInit {
  @ViewChild('form') form: FormCrearAreaComponent;

  // Output para comunicar al componente padre
  areaCreated = output<TeledeteccionArea | undefined>();

  titulo = 'Crear una nueva área';
  isLoading = signal(false);
  labelPrimaryButton = signal('Crear área');
  error = signal<string | null>(null);
  isSuccess = signal(false);
  labelSecondaryButton = computed(() =>
    this.isSuccess() ? 'Cerrar' : 'Cancelar'
  );
  subtitulo = computed(() => {
    return this.isSuccess()
      ? ''
      : 'Asigna un nombre e indica algunos datos para crear el área delimitada.';
  });

  constructor(public modalFormService: ModalFormService) {}

  ngOnInit() {
    this.modalFormService.showingModal.subscribe(() => {
      this.error.set(null);
    });
  }

  cancelar() {
    // Lógica para cancelar la acción
    this.modalFormService.showingModal.next(false);
    this.modalFormService.closeDrawer.next(true);
  }

  guardar() {
    // Lógica para guardar la acción
    this.form?.onSubmit();
  }

  get disabledButton(): boolean {
    return (
      !this.form?.isValidForm() || this.form?.isLoading() || this.isSuccess()
    );
  }

  onSuccessChange(success: boolean) {
    this.isSuccess.set(success);
  }

  onAreaCreated(area: TeledeteccionArea | undefined) {
    // Emitir al componente padre
    this.error.set(null);
    this.areaCreated.emit(area);
  }

  onSubmitError(error: string | string[] | null) {
    // Si el formulario emite un array de errores (detail[]), unirlos por saltos de línea
    const normalized = Array.isArray(error)
      ? error.filter(Boolean).join('\n')
      : error;
    this.error.set(normalized ?? null);
    this.isLoading.set(false);
    this.isSuccess.set(false);
  }

  ngOnDestroy() {
    this.error.set(null);
    this.isSuccess.set(false);
    this.isLoading.set(false);
  }
}
